"use client";

import { CloseIcon, InfoIcon } from "@/components/ui/atoms/icons";

interface SongHeaderProps {
  title: string | null;
  composer: string | null;
  onClose: () => void;
  /**
   * Optional : when provided, the title block becomes clickable and an
   * "ⓘ Aperçu" button appears next to the close button. Both call this
   * callback. Used by the default studio sidebar to re-open the
   * `PieceOverview` overlay after the user dismissed it.
   */
  onShowOverview?: () => void;
}

/**
 * Bandeau "morceau courant" affiché en haut des sidebars studio
 * (default + chords). Ne se rend pas si pas de titre.
 */
export function SongHeader({
  title,
  composer,
  onClose,
  onShowOverview,
}: SongHeaderProps) {
  if (!title) {
    return null;
  }

  const titleBlock = (
    <>
      <div className="truncate text-[13px] font-medium text-text-primary">
        {title}
      </div>
      {composer && (
        <div className="mt-0.5 truncate text-[11px] text-text-secondary">
          {composer}
        </div>
      )}
    </>
  );

  return (
    <div className="shrink-0 flex items-start gap-2 px-4 py-3 border-b border-border-subtle">
      {onShowOverview ? (
        <button
          type="button"
          onClick={onShowOverview}
          aria-label="Voir l'aperçu du morceau"
          title="Voir l'aperçu du morceau"
          className="min-w-0 flex-1 text-left -mx-1 px-1 py-0.5 rounded hover:bg-white/[0.04] transition-colors cursor-pointer"
        >
          {titleBlock}
        </button>
      ) : (
        <div className="min-w-0 flex-1">{titleBlock}</div>
      )}
      {onShowOverview ? (
        <button
          type="button"
          onClick={onShowOverview}
          aria-label="Voir l'aperçu du morceau"
          title="Voir l'aperçu du morceau"
          className="shrink-0 -mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-md text-text-muted hover:bg-white/[0.06] hover:text-text-primary cursor-pointer transition-colors"
        >
          <InfoIcon size={14} />
        </button>
      ) : null}
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer le morceau"
        title="Fermer le morceau"
        className="shrink-0 -mr-1 -mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-md text-text-muted hover:bg-white/[0.06] hover:text-text-primary cursor-pointer transition-colors"
      >
        <CloseIcon size={14} />
      </button>
    </div>
  );
}
